import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from 'ngx-toastr';
import { Toast } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

class CustomErrorToastService {
    constructor() { }
}
CustomErrorToastService.ɵfac = function CustomErrorToastService_Factory(t) { return new (t || CustomErrorToastService)(); };
CustomErrorToastService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomErrorToastService, factory: CustomErrorToastService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomErrorToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class CustomErrorToastComponent extends Toast {
    constructor(toastrService, toastPackage) {
        super(toastrService, toastPackage);
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
    }
    // Method to close the toast
    close() {
        this.toastPackage.triggerAction();
    }
    // Static method to display error toast
    static showErrorToast(toastrService, errorMessage) {
        const toastRef = toastrService.error(errorMessage, 'Error', {
            positionClass: 'toast-middle-center',
            closeButton: true,
            disableTimeOut: true,
            toastComponent: CustomErrorToastComponent,
        });
        // Add keydown listener for 'Enter' key
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                toastRef.toastRef.close();
            }
        });
    }
}
CustomErrorToastComponent.ɵfac = function CustomErrorToastComponent_Factory(t) { return new (t || CustomErrorToastComponent)(i0.ɵɵdirectiveInject(i1.ToastrService), i0.ɵɵdirectiveInject(i1.ToastPackage)); };
CustomErrorToastComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomErrorToastComponent, selectors: [["custom-error-toast"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 2, consts: [["id", "toast-container", 1, "toast-middle-center", "toast-container"], ["toast-component", "", 1, "ngx-toastr", "toast-error", 2, "opacity", "1"], ["aria-label", "Close", 1, "toast-close-button", 3, "click"], ["aria-hidden", "true"], ["aria-label", "Error", 1, "toast-title"], [3, "innerHTML"], [1, "toast-footer"], [1, "btn", "btn-danger", "btn-xs", "pull-right", 3, "click"]], template: function CustomErrorToastComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "button", 2);
        i0.ɵɵlistener("click", function CustomErrorToastComponent_Template_button_click_2_listener() { return ctx.close(); });
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4, "\u00D7");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "button", 7);
        i0.ɵɵlistener("click", function CustomErrorToastComponent_Template_button_click_9_listener() { return ctx.close(); });
        i0.ɵɵtext(10, "OK");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", ctx.message, i0.ɵɵsanitizeHtml);
    } }, styles: [".toast-footer[_ngcontent-%COMP%]{margin-top:10px;text-align:center}.toast-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:0!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomErrorToastComponent, [{
        type: Component,
        args: [{
                selector: 'custom-error-toast',
                templateUrl: './custom-error-toast.component.html',
                styleUrls: ['./custom-error-toast.component.scss']
            }]
    }], function () { return [{ type: i1.ToastrService }, { type: i1.ToastPackage }]; }, null); })();

class CustomErrorToastModule {
}
CustomErrorToastModule.ɵfac = function CustomErrorToastModule_Factory(t) { return new (t || CustomErrorToastModule)(); };
CustomErrorToastModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomErrorToastModule });
CustomErrorToastModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ButtonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomErrorToastModule, { declarations: [CustomErrorToastComponent], imports: [CommonModule,
        ButtonModule], exports: [CustomErrorToastComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomErrorToastModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomErrorToastComponent],
                imports: [
                    CommonModule,
                    ButtonModule,
                ],
                exports: [CustomErrorToastComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-error-toast
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomErrorToastComponent, CustomErrorToastModule, CustomErrorToastService };
//# sourceMappingURL=custom-error-toast.js.map
